export default "__VITE_ASSET__DgYbjRXC__"